<template>
  <HeadWithLogo/>
  <p class="text-justify ">
    سلام علیکم<br>
    شما فرهیخته گرامی، از طریق یکی از نهادهای مورد تایید نیروی انتظامی جهت دریافت نرم افزار سامانه برخط ناظر یک معرفی  و پیشنهاد شده اید.<br>
    سامانه برخط ناظر یک؛ نرم افزاری در تلفن همراه جهت ثبت کشف حجاب در خودرو است که زیر نظر پلیس امنیت اخلاقی فرماندهی نیروی انتظامی جمهوری اسلامی تعریف شده است.<br>
    در این سامانه ثبت نام:<br>
    ابتدا نرم افزار ناظر یک به شما معرفی میگردد.<br>
    پس از اطلاع اجمالی شما از عملکرد این سامانه، در صورت درخواست شما برای همکاری با این سامانه، ثبت نام اولیه را انجام داده و وارد مرحله بعد خواهید شد.<br>
    در مرحله بعد، نحوه استفاده از این سامانه آموزش داده و سپس از محتوای آن آزمون کوتاهی جهت اخذ خواهد شد.<br>
    نهایتا لازم است اطلاعات تکمیلی را وارد نموده و منتظر دریافت پیامک پلیس امنیت اخلاقی جهت راه اندازی نرم افزار برخط ناظر یک بر روی تلفن همراهتان باشید.<br>

    نکات:<br>
    اول: افرادی که سن قانونی ندارد تایید نخواهند شد.<br>
    دوم: در صورت عدم کسب امتیاز لازم در آزمون و یا عدم تعیین معرف و یا احراز شرایط لازم، دعوت به همکاری انجام نخواهد شد.<br>
    سوم: در صورت تایید ثبت نام در این سامانه آموزشی، امکان دارد دریافت پیامک نرم افزار تا دو هفته طول بکشد.<br>
    جهت مشاهده سایر توضیحات و ادامه فرآیند ثبت نام، بر روی عبارت (صفحه بعد)  که در پایین همه صفحات می باشد، بزنید.
  </p>
  <div class="text-center mt-3">
    <span class="sp-danger"> در صورت وجود سوال یا اشکال، در پیام رسان واتساپ، ایتا و بله به شماره 09960936122 پیام دهید. </span>
  </div>
  <div class="row mt-3">
    <div class="col-12 text-start">
      <RouterLink to="/introSecond" class="btn btn-success px-4">
        صفحه بعد
      </RouterLink>
    </div>
  </div>
</template>
<style>
.intro-text{
  font-family: Calibri,sans-serif;
}
.police-logo{
  display: block;
}
</style>
<script>
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  components: {HeadWithLogo}
}
</script>
